/* LWL — Ürün ölçüleri: seçili beden vurgusu, tablodan beden seçme, cm/inç, beden seçici yanındaki panel, büyük görsel.
   Ürün sayfasındaki beden düğmeleri: [data-lu-size] [data-lu-v] (aria-checked). Veri: [data-luo-json]. */
(function () {
	if (window.__luoInit) return;
	window.__luoInit = true;
	var box = document.querySelector('[data-luo]');
	if (!box) return;
	var home = box.parentNode;
	var data = {};
	try { data = JSON.parse(box.querySelector('[data-luo-json]').textContent); } catch (e) {}
	window.LWL_OLCU = data;
	var unit = 'cm';
	try { if (localStorage.getItem('lwlOlcuBirim') === 'in') unit = 'in'; } catch (e) {}

	function sizeGroup() { return document.querySelector('[data-lu-size]'); }
	function currentSize() {
		var g = sizeGroup();
		var b = g && g.querySelector('[data-lu-v][aria-checked="true"]');
		return b ? b.getAttribute('data-lu-v') : '';
	}
	function norm(s) { return String(s || '').trim().toUpperCase(); }
	function mark() {
		var s = norm(currentSize());
		var any = false;
		box.querySelectorAll('[data-luo-s]').forEach(function (tr) {
			var on = s && norm(tr.getAttribute('data-luo-s')) === s;
			tr.classList.toggle('is-sel', !!on);
			if (on) any = true;
		});
		var h = box.querySelector('[data-luo-hint]');
		if (h) h.innerHTML = any ? 'Seçili beden: <b>' + currentSize().split(' (')[0] + '</b>' : 'Bedeninize dokunun, ölçüleri karşılaştırın.';
	}
	function fmt(v) {
		if (v === '' || v == null || isNaN(v)) return '';
		var n = unit === 'in' ? v / 2.54 : +v;
		var r = Math.round(n * (unit === 'in' ? 10 : 2)) / (unit === 'in' ? 10 : 2);
		return String(r).replace('.', ',');
	}
	function setUnit(u) {
		unit = u;
		try { localStorage.setItem('lwlOlcuBirim', u); } catch (e) {}
		box.querySelectorAll('[data-luo-unit]').forEach(function (b) {
			var on = b.getAttribute('data-luo-unit') === u;
			b.classList.toggle('is-on', on);
			b.setAttribute('aria-pressed', on ? 'true' : 'false');
		});
		box.querySelectorAll('td[data-cm]').forEach(function (td) { td.textContent = fmt(parseFloat(td.getAttribute('data-cm'))); });
	}

	/* panel (beden seçicinin yanındaki "Ürün ölçüleri" bağlantısı) */
	var sh, shBody, open = false;
	function title() {
		var t = document.querySelector('.lu__title, h1');
		return t ? t.textContent.trim() : '';
	}
	function openPanel() {
		if (!sh) {
			sh = document.createElement('div');
			sh.className = 'lu-sh lu-x luo-x';
			sh.innerHTML = '<div class="lu-sh__bg" data-close></div><div class="lu-sh__p" role="dialog" aria-modal="true" aria-label="Ürün ölçüleri"><div class="lu-sh__grab"></div>' +
				'<div class="lu-sh__h"><div><b>Ürün ölçüleri</b><span></span></div><button type="button" class="lu-sh__x" data-close aria-label="Kapat">' +
				'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div data-b></div></div>';
			document.body.appendChild(sh);
			shBody = sh.querySelector('[data-b]');
			sh.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closePanel(); });
			document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePanel(); closeLb(); } });
			window.addEventListener('popstate', function () { if (open) closePanel(true); });
		}
		sh.querySelector('.lu-sh__h span').textContent = title();
		shBody.appendChild(box);
		sh.classList.add('is-open');
		document.body.classList.add('lu-noscroll');
		open = true;
		try { history.pushState({ luoSh: 1 }, ''); } catch (e) {}
		mark();
	}
	function closePanel(fromPop) {
		if (!open) return;
		sh.classList.remove('is-open');
		document.body.classList.remove('lu-noscroll');
		home.appendChild(box);
		open = false;
		if (fromPop !== true) { try { if (history.state && history.state.luoSh) history.back(); } catch (e) {} }
	}

	/* büyük görsel */
	var lb;
	function openLb(src) {
		if (!lb) {
			lb = document.createElement('div');
			lb.className = 'luo-lb';
			lb.innerHTML = '<button type="button" aria-label="Kapat">×</button><img alt="Ürün ölçüleri">';
			lb.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') closeLb(); });
			document.body.appendChild(lb);
		}
		lb.querySelector('img').src = src;
		lb.classList.add('is-open');
	}
	function closeLb() { if (lb) lb.classList.remove('is-open'); }

	document.addEventListener('click', function (e) {
		if (e.target.closest('[data-luo-open]')) { e.preventDefault(); openPanel(); return; }
		var u = e.target.closest('[data-luo-unit]');
		if (u) { setUnit(u.getAttribute('data-luo-unit')); return; }
		var z = e.target.closest('[data-luo-zoom]');
		if (z) { openLb(z.getAttribute('data-luo-zoom')); return; }
		if (e.target.closest('[data-luo-how]')) {
			var d = document.querySelector('[data-luo-howto]');
			if (open) closePanel();
			if (d) { d.open = true; setTimeout(function () { d.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60); }
			return;
		}
		var tr = e.target.closest('[data-luo-s]');
		if (tr && box.contains(tr)) {
			var s = tr.getAttribute('data-luo-s');
			var g = sizeGroup();
			var btn = g && Array.prototype.find.call(g.querySelectorAll('[data-lu-v]'), function (b) { return norm(b.getAttribute('data-lu-v')) === norm(s); });
			if (btn) btn.click();
			setTimeout(mark, 30);
			return;
		}
		if (e.target.closest('[data-lu-v]')) setTimeout(mark, 30);
	});
	var g = sizeGroup();
	if (g && window.MutationObserver) new MutationObserver(mark).observe(g, { subtree: true, attributes: true, attributeFilter: ['aria-checked'] });
	setUnit(unit);
	mark();
})();
